export default __webpack_public_path__ + "static/media/r100_s.b3b4d0b8.jpg";